import { render } from "./UserIdentificationTab.vue?vue&type=template&id=3571f018&scoped=true&ts=true"
import script from "./UserIdentificationTab.vue?vue&type=script&lang=ts"
export * from "./UserIdentificationTab.vue?vue&type=script&lang=ts"

import "./UserIdentificationTab.vue?vue&type=style&index=0&id=3571f018&scoped=true&lang=postcss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3571f018"]])

export default __exports__